import React from 'react'
import styles from './home.module.css'
import Section from "../../Components/Section/Section";
import aboutImage from '../../assets/aboutImage.png'
import aboutImageMobile from '../../assets/aboutImageMobile.jpg'
import { NavHashLink } from 'react-router-hash-link'
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen';
function About() {
  const isSmallScreen = useIsSmallScreen();
  return (
    <Section id="about" shrink>
        <div className={styles.aboutContainer}>
            <div data-reveal className={styles.aboutImageWrapper}>
                {isSmallScreen ? <img src={aboutImageMobile} alt="About" /> : <img src={aboutImage} alt="About" />}
            </div>
            <div className={styles.aboutContent}>
                <div data-reveal className={styles.homeHeaderContainer}>
                    <h1 className={styles.smallHeader}>About Me</h1>
                    <h2 className={styles.largeHeader}>Meet the artist</h2>
                </div>
                <div data-reveal className={styles.aboutTextContainer}>
                    <p className={styles.bodyText}>
                        Hi, I'm Astraea, the nail artist behind NailsByAstraea. My passion for nail artistry began when I was 12, when nails were simply a hobby, and has since grown into something much more meaningful: helping others feel confident through creativity and self-expression. Inspired by the details and little things that make every set unique, I strive to create a beautiful and welcoming space where every client feels comfortable, confident, and cared for.
                    </p>
                </div>

                <div data-reveal className={styles.actionRow}>
                    <NavHashLink smooth to="/home#services" className={styles.actionPrimary}>My Services</NavHashLink>
                    <NavHashLink smooth to="/home#contact" className={styles.actionSecondary}>Get In Touch</NavHashLink>
                </div>
            </div>
        </div>
    </Section>
  )
}
export default About
